import React, { Component } from "react";
import FlexView from "react-flexview";
import Button from "../../../../modules/commons/Button";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import { fetchDataAsync, wildcardToRegex } from "../../../../Services/Utils";
import { HttpStatus } from "../../../common/Constants";
import {
  INITIAL_VALUE_STOCK_PART,
  INITIAL_VALUE_STOCK_UNIT,
  tableStockConfig,
} from "../config";
import service from "../service";
import { defaultTableChange } from "../../../../modules/custom/customTable";
export default class StockUnitTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warnaOptions: [],
      keyword: null,
      appliedSearch: null,
      error: {},
      pagination: {
          page: 1,
          limit: 5,
          totalData: 0,
      },
    };
  }

  handleAddData = () => {
    const tab = this.props.tab;
    const initialData =
      tab === "unit" ? INITIAL_VALUE_STOCK_UNIT : INITIAL_VALUE_STOCK_PART;
    const tableKey = tab === "unit" ? "dataUnit" : "dataPart";

    this.props.onSetState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [tableKey]: [...prev.data[tableKey], initialData],
      },
    }));
  };

  handleKodePartChange = (index, name, value) => {
    if (this.isDuplicate(index, name, value?.value)) {
      this.handleDataExist(index);
      return;
    }

    let nama = null;
    if (value) {
      console.log(this.props.partOptions, value);
      nama = this.props.partOptions.find(
        (item) => item.kodePart === value?.value
      );
    }

    const namaPart =
      nama === null
        ? null
        : {
            label: nama.partName,
            value: nama.kodePart,
          };
    this.handleValueChange(index, name, value);
    this.handleValueChange(index, "namaPart", namaPart);
  };

  handleNamaPartChange = (index, name, value) => {
    if (this.isDuplicate(index, name, value?.value)) {
      this.handleDataExist(index);
      return;
    }
    this.handleValueChange(index, name, value);

    let kode = null;
    if (value) {
      kode = this.props.partOptions.find(
        (item) => item.kodePart === value?.value
      );
    }

    const kodePart =
      kode === null
        ? null
        : {
            label: kode.kodePart,
            value: kode.kodePart,
          };

    this.handleValueChange(index, "partCode", kodePart);
  };

  fetchDataWarna = async (value) => {
    this.props.handleLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam,
      setError: this.props.setError,
      menuName: "Stock Unit",
      args: {
        paramFilters: {
          kodeVariant: value,
        },
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        warnaOptions: res.data.data,
      });
    }
    this.props.handleLoading();
  };

  handleKodeVarianChange = (index, name, value) => {
    this.handleValueChange(index, name, value);

    let nama = null;
    if (value) {
      nama = this.props.variantOptions.find(
        (item) => item.kodeVariant === value?.value
      );
    }

    const namaVar =
      nama === null
        ? null
        : {
            label: nama?.namaVariant,
            value: nama?.kodeVariant,
          };

    this.handleValueChange(index, "namaVariant", namaVar);

    this.handleValueChange(index, "namaWarna", null);
    this.handleValueChange(index, "kodeWarna", null);
  };

  handleNamaVarianChange = (index, name, value) => {
    this.handleValueChange(index, name, value);
    let kode = null;
    if (value) {
      kode = this.props.variantOptions.find(
        (item) => item.kodeVariant === value?.value
      );
    }

    const kodeVar =
      kode === null
        ? null
        : {
            label: kode.kodeVariant,
            value: kode.kodeVariant,
          };
    this.handleValueChange(index, "kodeVariant", kodeVar);
    this.handleValueChange(index, "namaWarna", null);
    this.handleValueChange(index, "kodeWarna", null);
  };

  handleDataExist = (index) => {
    const isUnit = this.props.tab === "unit";
    const initialData = isUnit
      ? INITIAL_VALUE_STOCK_UNIT
      : INITIAL_VALUE_STOCK_PART;
    const tableKey = isUnit ? "dataUnit" : "dataPart";
    const info = isUnit
      ? "Warna untuk varian sudah ada dalam daftar. Silahkan pilih warna lain"
      : "Part sudah ada dalam daftar. Silahkan pilih part lain";

    this.props.handleAlertInfo("Informasi", info);
    this.props.onSetState((prev) => {
      const newState = [...prev.data[tableKey]];
      newState[index] = initialData;
      return {
        ...prev,
        data: {
          ...prev.data,
          [tableKey]: newState,
        },
      };
    });
  };

  handleKodeWarnaChange = (index, name, value) => {
    if (this.isDuplicate(index, name, value?.value)) {
      this.handleDataExist(index);
      return;
    }
    let warna = null;
    if (value) {
      warna = this.state.warnaOptions.find((item) => item.id === value?.value);
    }

    const valNamaWarna =
      warna === null
        ? null
        : {
            label: warna.namaWarnaPabrik,
            value: warna.id,
          };
    this.handleValueChange(index, name, value);
    this.handleValueChange(index, "namaWarna", valNamaWarna);
  };

  handleNamaWarnaChange = (index, name, value) => {
    if (this.isDuplicate(index, name, value?.value)) {
      this.handleDataExist(index);
      return;
    }
    this.handleValueChange(index, name, value);
    let warna = null;
    if (value) {
      warna = this.state.warnaOptions.find((item) => item.id === value?.value);
    }

    const valKodeWarna =
      warna === null
        ? null
        : {
            label: warna.kodeWarna,
            value: warna.id,
          };

    this.handleValueChange(index, "kodeWarna", valKodeWarna);
  };

  isDuplicate = (index, name, value) => {
    const key = name.includes("part") ? "partCode" : "kodeVariant";
    return this.props.dataTable.find(
      (item) =>
        item?.[key]?.value === this.props.dataTable[index]?.[key]?.value &&
        item[name]?.value === value
    );
  };

  handleValueChange = (index, name, value) => {
    const tab = this.props.tab;
    const tableKey = tab === "unit" ? "dataUnit" : "dataPart";

    this.props.onSetState((prev) => {
      const newState = [...prev.data[tableKey]];

      newState[index] = {
        ...newState[index],
        [name]: value,
      };
      return {
        ...prev,
        data: {
          ...prev.data,
          [tableKey]: newState,
        },
      };
    });
  };

  handleDelete = (index) => {
    const { tab, onSetState } = this.props;

    onSetState((prev) => {
      const dataKey = tab === "unit" ? "dataUnit" : "dataPart";
      const errorsForTab = { ...(prev.errors?.[tab] || {}) };

      delete errorsForTab[index];

      const updatedErrors = Object.values(errorsForTab).reduce(
        (acc, err, idx) => {
          acc[idx] = err;
          return acc;
        },
        {}
      );

      return {
        ...prev,
        data: {
          ...prev.data,
          [dataKey]: prev.data[dataKey].filter((_, i) => i !== index),
        },
        errors: {
          ...prev.errors,
          [tab]: updatedErrors,
        },
      };
    });
  };

  toggleCorrection = (index, value) => {
    this.handleValueChange(index, "isSaved", false);
  };

  decideDataTable = (pattern) => {
    const isUnit = this.props.tab === "unit";
    if (!pattern) return this.props.dataTable;

    const regex = wildcardToRegex(pattern);
    this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
            ...prevValue.pagination,
            totalData: this.props.dataTable.length,
        }
    }));
    return (
      this.props.dataTable.filter((item) => {
        const value = isUnit ? item.namaVariant?.label : item?.namaPart?.label;
        return value && regex.test(String(value));
      }) || []
    );
  };

  handleSaveCorrection = (index) => {
    const { tab, dataTable, onSetState } = this.props;
    const rowData = dataTable[index];
    const validationResult = service.validateRow(rowData, tab);
    const hasError = Object.values(validationResult).some((v) => v !== null);

    onSetState((prev) => {
      const updatedErrors = { ...prev.errors?.[tab] };

      if (hasError) {
        updatedErrors[index] = validationResult;
      } else {
        delete updatedErrors[index];
      }

      return {
        ...prev,
        errors: {
          ...prev.errors,
          [tab]: updatedErrors,
        },
      };
    });

    if (!hasError) {
      this.handleValueChange(index, "isSaved", true);
    }
  };

  getTableConfig = () => {
    return this.props.tab === "unit"
      ? tableStockConfig.unit({
          dataTable: this.props.dataTable,
          toggleCorrection: this.toggleCorrection,
          handleDelete: this.handleDelete,
          handleValueChange: this.handleValueChange,
          warnaOptions: this.state.warnaOptions,
          variantOptions: this.props.variantOptions,
          handleNamaVarianChange: this.handleNamaVarianChange,
          handleKodeVarianChange: this.handleKodeVarianChange,
          handleKodeWarnaChange: this.handleKodeWarnaChange,
          handleNamaWarnaChange: this.handleNamaWarnaChange,
          isReadonly: this.props.isReadonly,
          fetchDataWarna: this.fetchDataWarna,
          onSaveCorrection: this.handleSaveCorrection,
          errors: this.props.errors,
        })
      : tableStockConfig.part({
          dataTable: this.props.dataTable,
          handleValueChange: this.handleValueChange,
          toggleCorrection: this.toggleCorrection,
          handleDelete: this.handleDelete,
          partOptions: this.props.partOptions,
          handleKodePartChange: this.handleKodePartChange,
          handleNamaPartChange: this.handleNamaPartChange,
          isReadonly: this.props.isReadonly,
          onSaveCorrection: this.handleSaveCorrection,
          errors: this.props.errors,
        });
  };

  handleClearSearch = () => {
    this.setState((prev) => ({
      ...prev,
      appliedSearch: null,
      keyword: null,
    }));
  };

  handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: tableState.page + 1,
          }
      }));
  };
  handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
          ...prevValue,
          pagination:{
              ...prevValue.pagination,
              page: 1,
              limit: tableState.rowsPerPage,
          }
      }));
  };

  render() {
    const {pagination} = this.state;
    const isUnit = this.props.tab === "unit";
    // console.log(this.props);
    return (
      <React.Fragment>
        <FlexView
          vAlignContent="center"
          style={{ justifyContent: "space-between", marginBottom: "15px" }}
        >
          <SimpleButton
            styles={{ marginLeft: 0 }}
            text="Tambah"
            secondary={this.props.isReadonly}
            disabled={this.props.isReadonly}
            onClick={this.handleAddData}
            icon={<i className="fa fa-plus margin margin-right-5px" />}
          />
          <FlexView
            vAlignContent="center"
            style={{ gap: "15px", marginTop: "15px" }}
          >
            <SimpleInput
              id="input_name"
              placeholder={`Input Nama ${isUnit ? "Varian" : "Part"}`}
              containerclassname="width width-250px"
              value={this.state.keyword}
              onChange={({ target }) =>
                this.setState({ keyword: target.value })
              }
            />
            <Button
              className="btnAct background-transparent txt-site txt-standar margin margin-bottom-15px"
              type="button"
              onClick={() =>
                this.setState((prev) => ({
                  ...prev,
                  appliedSearch: prev.keyword,
                }))
              }
            >
              <i className={`fa fa-search`} />
            </Button>
            <Button
              className="btnAct background-transparent txt-site txt-standar margin margin-bottom-15px"
              type="button"
              onClick={this.handleClearSearch}
            >
              <i className={`fa fa-times`} />
            </Button>
          </FlexView>
        </FlexView>
        <SimpleDataTable
          key={`${pagination.totalData}-${pagination.page}`}
          data={this.decideDataTable(this.state.appliedSearch)}
          columns={this.getTableConfig()}
          toCount={pagination.totalData}
          rowsPerPage={pagination.limit}
          page={pagination.page - 1}
          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}

        />
      </React.Fragment>
    );
  }
}
